import { h } from 'preact';
import clsx from 'clsx';
import useResponsive from 'utils/responsive';
import { useState, useEffect } from 'preact/hooks';
import middleware from 'utils/middleware';

const ProductSwatch = ({
  product,
  selected,
  onChange,
  initHasLowInventory,
}) => {
  const { breakPoint } = useResponsive();
  const isMobile = breakPoint !== 'lg';
  const [productHasLowInventory, setProductHasLowInventory] = useState(false);

  const setInitHasLowInventory = (hasLowInventory) => {
    if (initHasLowInventory) initHasLowInventory(hasLowInventory);
    setProductHasLowInventory(hasLowInventory);
  };

  useEffect(() => {
    if (!product) return;

    const getInventory = async (readVariantId) => {
      const response = await middleware.getVariantInventory(readVariantId);
      if (!response.data) {
        // eslint-disable-next-line no-console
        console.error('product-form.js: Middleware request failed', response);
        return [];
      }
      return response.data.productVariant.inventoryItem.inventoryLevel
        .quantities[0].quantity;
    };

    const getAllInventory = async () => {
      const promises = product.variants.map((variant) =>
        getInventory(variant.id.split('/ProductVariant/')[1]),
      );

      await Promise.all(promises).then((variantsInventories) => {
        const totalInventory = variantsInventories.reduce(
          (partialSum, a) => partialSum + a,
          0,
        );
        const hasLowInventory = totalInventory > 0 && totalInventory <= 5;
        if (selected) setInitHasLowInventory(hasLowInventory);
        else setProductHasLowInventory(hasLowInventory);
      });
    };

    if (window.TMW.enableLowStockBadge) {
      getAllInventory();
    }
  }, []);

  return (
    <div
      onClick={() => onChange(product, 'click', productHasLowInventory)}
      onMouseEnter={() =>
        !isMobile && onChange(product, 'hover', productHasLowInventory)
      }
      onMouseLeave={() => !isMobile && onChange(null, 'hover')}
      className={clsx(
        'mx-2 rounded-full border-black bg-white h-[15px] w-[15px] flex items-center justify-center',
        {
          'border border-black selected': selected,
        },
      )}
    >
      <div
        style={{
          backgroundImage: `url(${product.swatchImage?.reference?.image?.src})`,
        }}
        className={clsx(
          'card-swatch rounded-full border-black bg-white overflow-hidden flex items-center justify-center bg-contain box-border',
          {
            selected,
          },
        )}
      ></div>
    </div>
  );
};

export default ProductSwatch;
